import { render, staticRenderFns } from "./choice.vue?vue&type=template&id=7c606126&scoped=true&"
var script = {}
import style0 from "./choice.vue?vue&type=style&index=0&id=7c606126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c606126",
  null
  
)

export default component.exports